export const GET_REPLY_REQUEST = "GET_REPLY_REQUEST";
export const GET_REPLY_RECEIVE = "GET_REPLY_RECEIVE";
export const GET_REPLY_FAILURE = "GET_REPLY_FAILURE";
export const RESET_GET_REPLY = "RESET_GET_REPLY";

export const CREATE_REPLY_REQUEST = "CREATE_REPLY_REQUEST";
export const CREATE_REPLY_RECEIVE = "CREATE_REPLY_RECEIVE";
export const CREATE_REPLY_FAILURE = "CREATE_REPLY_FAILURE";
export const RESET_CREATE_REPLY = "RESET_CREATE_REPLY";

export const UPDATE_REPLY_REQUEST = "UPDATE_REPLY_REQUEST";
export const UPDATE_REPLY_RECEIVE = "UPDATE_REPLY_RECEIVE";
export const UPDATE_REPLY_FAILURE = "UPDATE_REPLY_FAILURE";
export const RESET_UPDATE_REPLY = "RESET_UPDATE_REPLY";

export const DELETE_REPLY_REQUEST = "DELETE_REPLY_REQUEST";
export const DELETE_REPLY_RECEIVE = "DELETE_REPLY_RECEIVE";
export const DELETE_REPLY_FAILURE = "DELETE_REPLY_FAILURE";
export const RESET_DELETE_REPLY = "RESET_DELETE_REPLY";